import React from 'react';
import { SvgIcon, SvgIconProps } from '@material-ui/core';

export const CompanyIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 7 7" {...props}>
    <path d="M7.125 5.66437H6.375V2.66438H6.75H7.125V1.91438C7.125 1.76587 7.038 1.63162 6.90225 1.57162L3.36525 0L0.207375 1.57875C0.08025 1.64213 0 1.77225 0 1.91438V2.66438H0.375H0.75V5.66437H0V7.16437H7.125V5.66437ZM5.25 2.66438V5.66437H4.125V2.66438H5.25ZM1.875 2.66438H3V5.66437H1.875V2.66438Z" />
  </SvgIcon>
);
